/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IOrderTemplateNameDialogResources, OrderTemplateNameDialog } from '@msdyn365-commerce/components';
import { IComponentProps } from '@msdyn365-commerce/core';
import { Button } from '@msdyn365-commerce-modules/utilities';
import React, { useState } from 'react';

export interface ICreateOrderTemplateButtonProps extends IComponentProps {
    createOrderTemplateText: string;
    createOrderTemplateDialogResources: IOrderTemplateNameDialogResources;
    onOrderTemplateCreated(): Promise<void>;
}

const CreateOrderTemplateButton: React.FC<ICreateOrderTemplateButtonProps> = (props) => {
    const onCancelHandler = React.useCallback(() => {
        return;
    }, []);
    const [createOrderTemplateDialogOpen, setOrderTemplateNameDialogOpen] = useState(false);
    const onCreateButtonClick = React.useCallback(() => {
        setOrderTemplateNameDialogOpen(true);
    }, []);

    return (
        <>
            <Button
                className='ms-order-template__add-template-button'
                color='primary'
                onClick={onCreateButtonClick}
            >
                {props.createOrderTemplateText}
            </Button>
            <OrderTemplateNameDialog
                className='msc-order-template-name-dialog'
                modalOpen={createOrderTemplateDialogOpen}
                isUpdateDialog={false}
                setModalOpen={setOrderTemplateNameDialogOpen}
                context={props.context}
                id={props.id}
                data={{}}
                typeName={props.typeName}
                dialogStrings={props.createOrderTemplateDialogResources}
                onCancel={onCancelHandler}
                onSuccess={props.onOrderTemplateCreated}
            />
        </>
    );
};

export default CreateOrderTemplateButton;
